/**
 * Log level constants for request-iframe.
 */

export var LogLevel = {
  TRACE: 'trace',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error',
  SILENT: 'silent'
};